import { render } from "./SubMenuVP.vue?vue&type=template&id=ca6995d2&scoped=true"
import script from "./SubMenuVP.vue?vue&type=script&lang=js"
export * from "./SubMenuVP.vue?vue&type=script&lang=js"

import "./SubMenuVP.vue?vue&type=style&index=0&id=ca6995d2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6995d2"]])

export default __exports__